import { render, staticRenderFns } from "./NearbyPlace.vue?vue&type=template&id=dbdc6c76&scoped=true"
import script from "./NearbyPlace.vue?vue&type=script&lang=js"
export * from "./NearbyPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdc6c76",
  null
  
)

export default component.exports